import { render, staticRenderFns } from "./ImportDetails.vue?vue&type=template&id=3c0747a6&"
import script from "./ImportDetails.vue?vue&type=script&lang=js&"
export * from "./ImportDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports